<template>
    <v-list-item @click="goToRecord()">
        <template v-slot:prepend>
            <v-avatar>
                <img v-if="photo" :src="photo" />
                <v-icon v-else size="large">mdi-account-circle</v-icon>
            </v-avatar>
        </template>
        <v-list-item-title class="text-body-large">
            {{ user.displayName }}
        </v-list-item-title>
        <template v-slot:append>
            <span class="text-body-large">
                {{ displayStatus }}
            </span>
            <v-tooltip location="top" v-if="isDiscussion">
                <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-chat</v-icon>
                </template>
                <span class="text-body-large"
                    >There are additional comments in this review, click through
                    to see them</span
                >
            </v-tooltip>
        </template>
    </v-list-item>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const props = defineProps({
    type: { type: String },
    calc: { type: Object },
    record: { type: Object },
})

const store = useStore()
const router = useRouter()

const user = ref({})
const photo = ref(null)
const isDiscussion = ref(false)
const comments = ref([])

onMounted(async () => {
    const email = props.record.created_by.email
    user.value = await store.dispatch('getUser', email)
    photo.value = await store.dispatch('getUserPhoto', email)
})

// Use onMounted equivalent for created lifecycle
;(async () => {
    if (props.type === 'review') {
        comments.value = await store.dispatch(
            'getRecordComments',
            props.record.reference_id
        )
        if (comments.value.length > 1) isDiscussion.value = true
    }
})()

const displayStatus = computed(() => {
    if (props.type === 'review') {
        if (props.record.type.name === 'recommended') return 'Recommended'
        if (props.record.type.name === 'recommended_caveats')
            return 'Recommended With Caveats'
        if (props.record.type.name === 'not_recommended')
            return 'Not Recommended'
    } else if (props.type === 'skillsNetwork') {
        return props.record.reference_table
    } else if (props.type === 'projects') {
        return props.record.reference_table.split('/')[2]
    }
})

function goToRecord() {
    store.commit('SET_SELECTED_RECORD', props.record)
    let type = props.type
    if (type === 'skillsNetwork' || type === 'projects') type = 'approval'
    router.push({
        name: type + 's',
        params: {
            calcId: props.calc.calcId,
            recordId: props.record.reference_id,
        },
    })
}
</script>
<style scoped>
.userlist {
    background-color: rgba(97, 97, 97, 0.9) !important;
}
.transparent {
    background-color: transparent !important;
}
.tooltip-transp {
    background: none;
    padding: 0;
}
span {
    white-space: pre-wrap;
}
</style>
